import React from 'react';
import PageContent from '@bumble/app/components/PageContent';
import { Box, Card, CardContent, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import { COLORS } from '../theme';

export interface RegistrationContainerProps {
  children: React.ReactNode;
}
export const RegistrationContainer = ({ children }: RegistrationContainerProps) => {
  return (
    <PageContent hideNavContent>
      <Container fixed sx={{ flexGrow: 1 }}>
        <Box
          component="div"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          sx={{ height: '100vh' }}
        >
          <Card sx={{ width: '100%', maxWidth: '450px', textAlign: 'center' }}>
            <CardContent sx={{ padding: '40px' }}>
              <Box mb={2}>
                <Link to="/">
                  <ReactSVG
                    src="/logos/bumble-logo.svg"
                    beforeInjection={(svg) => {
                      svg.setAttribute('style', `width: 240px; color: ${COLORS.PRIMARY};`);
                    }}
                  />
                </Link>
              </Box>
              {children}
            </CardContent>
          </Card>
        </Box>
      </Container>
    </PageContent>
  );
};
